import React from "react";
import {PathName} from "routers/types";
import {useLocation} from "react-router-dom";

const PAGES_REAL_ESTATE: PathName[] = ["/"];

const HeroSearchForm2MobileFactory = () => {
  const pathname = useLocation().pathname;
  if (PAGES_REAL_ESTATE.includes(pathname as PathName)) {
    // return <FilterFormMobile />;
    return <></>;
  }
  // return <HeroSearchForm2Mobile />;
  return <></>;
};

export default HeroSearchForm2MobileFactory;
